import {
  Box,
  Card,
  Grid,
  Avatar,
  Chip,
  Stack,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Container,
  Tabs,
  Tab,
  Rating
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import PageHeader from 'src/components/pageHeader';
import {
  Star as StarIcon,
} from '@mui/icons-material';
import PageTypography from 'src/components/PageTypography/PageTypography';
import { useState } from 'react';
import { useLawyersDeshBoardQuery } from 'src/reduxServer/services/lawyer';
import { useParams } from 'react-router-dom';
import { consultationStatusColorMap, formatDMY, getCaseStatusColor, getStatusColor, statusColorMap } from 'src/utils/help';
import Loader from 'src/components/Loader';
import NoDataFound from 'src/components/NoDataFound';
import ChartGraph from 'src/components/ChartGraph';
import { useTranslation } from 'react-i18next';
import FormInputPage from 'src/components/FormFields/PageInput';
import { Helmet } from 'react-helmet-async';

const LawyerPageDeshboard = () => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState(0);
  const { id } = useParams();
  const [selectLimit, setSelectLimit] = useState(5)
  const theme = useTheme();
  const { data, isLoading } = useLawyersDeshBoardQuery({
    lawyer_id:id,
    limit: selectLimit

  });

  const caseData = data?.counts?.cases || {};
  const consultationData = data?.counts?.consultations || {};
  const lawyerData = data?.lawyer || {};
  const casesList = data?.recent?.cases || [];
  const consultationsList = data?.recent?.consultations || [];

  const caseStatCards = [
    {
      label: t("Total"),
      value: caseData?.total ?? 0,
      color: theme.palette.text.secondary,
    },
    {
      label: t("Draft"),
      value: caseData?.by_status?.draft ?? 0,
      color: theme.palette.warning.main,
    },
    {
      label: t("Ongoing"),
      value: caseData?.by_status?.ongoing ?? 0,
      color: theme.palette.info.main,
    },
    {
      label: t("Closed"),
      value: caseData?.by_status?.closed ?? 0,
      color: theme.palette.success.main,
    },
    {
      label: t("Rejected"),
      value: caseData?.by_status?.rejected ?? 0,
      color: theme.palette.error.main,
    },
  ];


  const consoltationStatCards = [
    {
      label: t("Total"),
      value: consultationData?.total ?? 0,
      color: theme.palette.text.secondary,
    },
    {
      label: t("Pending"),
      value: consultationData?.by_status?.pending ?? 0,
      color: theme.palette.warning.main,
    },
    {
      label: t("In Progress"),
      value: consultationData?.by_status?.in_progress ?? 0,
      color: theme.palette.info.main,
    },
    {
      label: t("Approved"),
      value: consultationData?.by_status?.approved ?? 0,
      color: theme.palette.success.light,
    },
    {
      label: t("Completed"),
      value: consultationData?.by_status?.completed ?? 0,
      color: theme.palette.success.main,
    },
    {
      label: t("Cancelled"),
      value: consultationData?.by_status?.cancelled ?? 0,
      color: theme.palette.error.main,
    },
  ];


  const chartData = activeTab === 0 ? caseStatCards : consoltationStatCards

  console.log("case Data>>>>", caseData);
  console.log("lawyer Deshboard Data>>>>", data);

  if (isLoading) {
    return <>
      <Loader />
    </>;
  }

  const limit = [
    {
      label: "5",
      value: '5'
    },
    {
      label: "10",
      value: '10'
    },
    {
      label: "25",
      value: '25'
    },
    {
      label: "50",
      value: '50'
    }
  ]



  return (
    <>
    {
      id && (
        <Helmet>
                <title>Lawyer Dashboard</title>
              </Helmet>
      )
    }
      { id && ( <PageTitleWrapper>
    <PageHeader
      title={t("Lawyer Dashboard")}

    />

      </PageTitleWrapper>)
    }
      <Container maxWidth="xl">
        { id &&(<Card sx={{ p: 3, borderRadius: 1, mb: 3 }}>
          <Stack direction="row" spacing={3} alignItems="center">


            <Box flex={1}>
              <PageTypography fontWeight={700} fontSize={18}>
                <b>{t("name")} :</b> {lawyerData?.name || "-"}
              </PageTypography>

              <PageTypography color="text.secondary" fontSize={14}>
                <b>{t("email")} :</b>  {lawyerData?.email || "-"}
              </PageTypography>

              <PageTypography color="text.secondary" fontSize={13}>
                <b>{t("Experience")} :</b> {lawyerData?.experience_years ?? 0} {t("year")}
              </PageTypography>

              <PageTypography color="text.secondary" fontSize={13}>

              </PageTypography>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <PageTypography color="text.secondary" fontSize={13}>
                  <b>{t('Rating')} :</b>      {lawyerData?.rating}
                </PageTypography>
                <Rating
                  value={lawyerData?.rating}
                  precision={0.5}
                  readOnly
                  max={5}
                  emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                />
              </Box>
            </Box>
          </Stack>
        </Card>)}

        {

          casesList.length === 0 &&
            consultationsList.length === 0
            ? (
              <NoDataFound />
            ) : (
              <>

                <PageTypography fontWeight={700} mb={2}>
                  {activeTab === 0 ? t("case_performance_analytics") : t("consultation_performance_analytics")}
                </PageTypography>




                <Grid container spacing={2}>
                  {(activeTab === 0 ? caseStatCards : consoltationStatCards).map((item, i) => (
                    <Grid item xs={12} sm={6} md={2} key={i}>
                      <Card
                        sx={{
                          p: 2,
                          textAlign: 'center',
                          borderRadius: 1,
                          color: item.color
                        }}
                      >
                        <PageTypography fontSize={22} fontWeight={700}>
                          {item.value}
                        </PageTypography>
                        <PageTypography fontSize={12}>{item.label}</PageTypography>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
                <Box mt={4}>
                  <ChartGraph
                    title=""
                    totalLabel={activeTab === 0 ? t("Total Cases") : t("Total Consultations")}
                    items={chartData || []}
                  />
                </Box>

                <Card sx={{ p: 3, borderRadius: 1, mb: 5, marginTop: 3 }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                  >
                    <PageTypography fontWeight={700}>
                      {activeTab === 0 ? t("Case History") : t("Consultations History")}
                    </PageTypography>

                    <Stack direction="row" alignItems={"center"} spacing={2} >
                      <Box ml={1}>
                        <FormInputPage
                          select
                          value={selectLimit}
                          onChange={(value) => setSelectLimit(Number(value))}
                          options={limit}

                        />
                      </Box>

                      <Tabs
                        value={activeTab}
                        onChange={(_, v) => setActiveTab(v)}
                        textColor="primary"
                        indicatorColor="primary"
                      >
                        <Tab label={t("Cases")} />
                        <Tab label={t("Consultations")} />
                      </Tabs>
                    </Stack>
                  </Stack>

                  <Divider />
                  {activeTab === 0 && (
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>{t("Case ID")}</TableCell>
                            <TableCell>{t("Title")}</TableCell>
                            <TableCell>{t("Court")}</TableCell>
                            <TableCell>{t("Status")}</TableCell>
                            <TableCell>{t("Last Filing Date")}</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {casesList.map((row, i) => (
                            <TableRow key={i}>
                              <TableCell>{row.id}</TableCell>
                              <TableCell>{row.title}</TableCell>
                              <TableCell>{row.court_name}</TableCell>
                              <TableCell>
                                <Chip
                                  label={t(row.status)}
                                  size="small"
                                  sx={{
                                    bgcolor: statusColorMap[row.status?.toLowerCase()] || "#e5e7eb",
                                    color: "#fff",
                                    fontWeight: 500,
                                  }}
                                />

                              </TableCell>
                              <TableCell>{formatDMY(row.created_at)}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                  {activeTab === 1 && (
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>{t("ID")}</TableCell>
                            <TableCell>{t("Title")}</TableCell>
                            <TableCell>{t("Type")}</TableCell>
                            <TableCell>{t("Status")}</TableCell>
                            <TableCell>{t("Date")}</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {consultationsList.map((row, i) => (
                            <TableRow key={i}>
                              <TableCell>{row.id}</TableCell>
                              <TableCell>{row.title}</TableCell>
                              <TableCell>{row.consultation_type}</TableCell>
                              <TableCell>
                                <Chip
                                  label={t(row.status)}
                                  size="small"
                                  sx={{
                                    bgcolor: consultationStatusColorMap[row.status?.toLowerCase()] || "#e5e7eb",
                                    color: "#fff",
                                    fontWeight: 500,
                                  }}
                                />
                              </TableCell>
                              <TableCell>{formatDMY(row.created_at)}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Card>
              </>
            )}


      </Container >
    </>
  );
};

export default LawyerPageDeshboard;